import React, { useMemo } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { formatTime, getPlanMapPoints } from './routePlannerUtils';

const LIMA_CENTER = [-12.0464, -77.0428];

function markerIcon(point) {
  const size = point.priority ? 34 : 28;
  const label = point.sequence || point.id;
  return L.divIcon({
    className: '',
    html: `
      <div style="
        width:${size}px;height:${size}px;border-radius:999px;
        background:${point.warning ? '#dc2626' : point.color};
        color:white;display:flex;align-items:center;justify-content:center;
        font-size:11px;font-weight:800;border:2px solid white;
        box-shadow:0 6px 14px rgba(15,23,42,.25);
      ">${label}</div>
    `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}

function FitBounds({ points }) {
  const map = useMap();
  React.useEffect(() => {
    if (!points.length) return;
    const bounds = L.latLngBounds(points.map((point) => [point.lat, point.lng]));
    map.fitBounds(bounds.pad(0.18), { maxZoom: 13 });
  }, [map, points]);
  return null;
}

function RoutePlanMap({ plan, preview }) {
  const points = useMemo(() => getPlanMapPoints(plan, preview), [plan, preview]);

  return (
    <section className="relative z-0 rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="font-bold text-slate-900">Mapa operativo</h2>
        <span className="text-sm text-slate-500">{points.length} puntos con ubicacion</span>
      </div>
      <div className="relative z-0 h-[420px] overflow-hidden rounded-lg border border-slate-200">
        <MapContainer center={LIMA_CENTER} zoom={11} scrollWheelZoom className="z-0 h-full w-full">
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <FitBounds points={points} />
          {points.map((point) => (
            <Marker key={`${point.route_id || 'preview'}-${point.id}`} position={[point.lat, point.lng]} icon={markerIcon(point)}>
              <Popup>
                <div className="text-sm">
                  <div className="font-bold">Entrega #{point.id}</div>
                  <div>{point.recipient_name}</div>
                  <div>{point.district || 'Sin distrito'} | Slot {point.slot || 0}</div>
                  {point.driver_name && <div>Driver: {point.driver_name}</div>}
                  {point.sequence && <div>Secuencia: {point.sequence}</div>}
                  {point.eta && <div>ETA: {formatTime(point.eta)}</div>}
                  {point.warning && <div className="font-bold text-red-600">{point.warning}</div>}
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </section>
  );
}

export default RoutePlanMap;
